import React, { useEffect } from 'react';
export var Deprecated = function Deprecated(Component) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var DeprecatedComponent = function DeprecatedComponent(props) {
    useEffect(function () {
      /* istanbul ignore next */
      if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'development') {
        console.warn("".concat(Component.displayName, " is deprecated."), message);
      }
    }, []);
    return /*#__PURE__*/React.createElement(Component, props);
  };

  DeprecatedComponent.displayName = 'DeprecatedComponent';
  return DeprecatedComponent;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/Deprecated.js
// module id = 555
// module chunks = 12